var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RequestWizardStep',{attrs:{"name":"Review"}},[_c('div',{staticClass:"d-flex flex-column"},[_c('h4',{staticClass:"mb-4"},[_vm._v("Please review the information you have entered before submitting:")]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }